import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '功能介绍', path: '/' },
      { label: '下载中心', path: '/#download' },
      { label: '更新日志', path: '/article/latest-version-4-2-0-release' },
      { label: '系统要求', path: '/article/complete-installation-guide' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '帮助中心', path: '/category/system-tools' },
      { label: '安装教程', path: '/article/complete-installation-guide' },
      { label: '常见问题', path: '/#faq' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  resources: {
    title: '资源',
    links: [
      { label: '使用技巧', path: '/category/office-tools' },
      { label: '视频教程', path: '/category/multimedia' },
      { label: '开发者工具', path: '/category/dev-tools' },
      { label: '社区论坛', path: '/' },
    ],
  },
  about: {
    title: '关于',
    links: [
      { label: '品牌故事', path: '/about' },
      { label: '用户评价', path: '/about#testimonials' },
      { label: '隐私政策', path: '/about' },
      { label: '服务条款', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-secondary-400 hover:text-background-50 transition-colors duration-200 text-sm whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-secondary-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-md bg-primary-500 flex items-center justify-center">
              <span className="text-background-50 font-bold text-xs font-label">91</span>
            </div>
            <span className="font-heading font-bold text-background-50 text-sm">91免费版</span>
          </div>

          <p className="text-secondary-500 text-xs">
            &copy; {new Date().getFullYear()} 91免费版 版权所有 | 永久免费 · 安全可靠
          </p>

          <div className="flex items-center gap-3">
            <a href="/" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-400 hover:text-background-50 hover:bg-primary-500 transition-all duration-200">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="/" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-400 hover:text-background-50 hover:bg-primary-500 transition-all duration-200">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="/" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-400 hover:text-background-50 hover:bg-primary-500 transition-all duration-200">
              <i className="ri-bilibili-line text-sm"></i>
            </a>
            <a href="/" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-400 hover:text-background-50 hover:bg-primary-500 transition-all duration-200">
              <i className="ri-github-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}